// extracted by mini-css-extract-plugin
module.exports = {"ironSettings":"IrnSettings_ironSettings__3cSOM"};